// extracted by mini-css-extract-plugin
export default {"card":"CoachesCard_card__EVck9","imgHolder":"CoachesCard_imgHolder__aWyKN","img":"CoachesCard_img__jb4UF","infoHolder":"CoachesCard_infoHolder__sQnUD"};